module.exports = __webpack_public_path__ + "static/media/nearbyShopsLogo.c24e1bff.svg";